import * as Sentry from '@sentry/vue';

export function createSentryMonitor (app, router) {
	Sentry.init({
		app,
		dsn: import.meta.env.VITE_SENTRY_DNS,
		integrations: [
			Sentry.browserTracingIntegration({ router }),
			Sentry.breadcrumbsIntegration({
				console: false,
			}),
		],

		tracesSampleRate: 0.1,

		// Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
		tracePropagationTargets: [
			'localhost',
			/^https:\/\/back-[a-z0-9]+\.sesametime\.com\/api/,
		],
	});
}
